<script setup lang="ts">
/**
 * Modale Inventaire : ouvre la vue Inventory en overlay (overlays.store) au lieu
 * d'une navigation pleine page. La route /inventory reste un deep-link.
 */
import { computed } from 'vue';
import { useOverlaysStore } from '@/stores/overlays.store';
import InventoryView from '@/views/game/InventoryView.vue';

const overlays = useOverlaysStore();
const open = computed({
  get: () => overlays.inventoryOpen,
  set: (v: boolean) => { overlays.inventoryOpen = v; },
});
</script>

<template>
  <el-dialog
    v-model="open"
    title="🎒 Inventaire"
    width="min(94vw, 1100px)"
    append-to-body
    destroy-on-close
    align-center
    class="overlay-dialog"
  >
    <InventoryView v-if="open" />
  </el-dialog>
</template>

<style scoped lang="scss">
// Corps à HAUTEUR FIXE : la modale ne change plus de taille selon le contenu.
// Le défilement est délégué aux zones internes (objets / composants).
.overlay-dialog :deep(.el-dialog__body) {
  height: 80vh;
  overflow: hidden;
  padding-top: 0;
  display: flex;
  flex-direction: column;
}
</style>
